import axios from 'axios';
import axiosvl from '../axios/axios-vl';
import store from '../store/index.js'
import {scale} from "@cloudinary/base/actions/resize";
import Cloudinary from './cloudinary';
import * as GCONST from '../constants.js';


class CloudinaryApi {

    item_sku;
    manufacturer_code;
    category_level;
    category_id;
    category_codes = [];
    category_2 = '';
    category_3 = '';
    category_4 = '';
    category_5 = '';
    category_6 = '';
    category_7 = '';
    category_8 = '';
    category_9 = '';
    category_9 = '';
    category_10 = '';
    diagram_id = '';
    slider_folder = '';

    productTag(tagName, scaleWidth = 0){
        let cl_api_url = store.getters.cl_api_url;
        cl_api_url += '/resources/image/tags/' + tagName;
        return axios.get(cl_api_url)
        .then((response) => {
            const resources = response.data.resources;

            if(resources.length > 0) {
                const clImage = Cloudinary.image(resources[0].public_id);
                if (scaleWidth > 0){
                    clImage.resize(scale().width(scaleWidth));
                }
                return clImage.toURL();
            }else{
                return false;
            }
        })
        .catch(function (error) {
            console.log("error - " + error);
        });
    }

    manufacturerTag(tagName, scaleWidth = 0){
        let cl_api_url = store.getters.cl_api_url;
        cl_api_url += '/resources/image/tags/' + tagName;
        return axios.get(cl_api_url)
        .then((response) => {
            const resources = response.data.resources;
            if(resources.length > 0) {
                const clImage = Cloudinary.image(resources[0].public_id);
                if (scaleWidth > 0){
                    clImage.resize(scale().width(scaleWidth));
                }
                return clImage.toURL();
            }else{
                return GCONST.THUMB_IMAGE_PLACEHOLDER;
            }
        })
        .catch(function (error) {
            console.log("error - " + error);
        });
    }

    vlImageByTag(tagName){
        
        const url = 'https://demo.qwik-orderplus.com/d15pgmlib/lansaweb?w=CLMWAPI&r=SearchByTag&part=cml';

        axiosvl.post(url, {
            "webroutine": {
                "context": {
                    "session-key-method": "hidden"
                },   
                "fields": {
                    "LW3SFID": {"value": store.getters.storefront},
                    "TAGNAME": {"value": tagName}
                },   
            }
        })
        .then(() => {
            // const fields = response.data.webroutine.fields;
            // console.log(fields);
            // const json_resp = JSON.parse(fields.JSON_RESP.value);
            // if (json_resp.resources.length > 0){

            // }else{

            // }
        });
    }

    /**
     * 
     * @param {*} meta key
     * @param {*} scaleWidth (optional: scale width of the image)
     * @param {*} publicIdOnly  (optional: sets as a flag to return public ID only else image URL)
     * @returns 
     */
    vlImageByMeta(meta, scaleWidth = 0, publicIdOnly = false){

        const meta_value = this.__metaValue(meta);
        const url = store.getters['api/cl_mware_uri'];
        
        return axiosvl.post(url, {
            "webroutine": {
                "context": {
                    "session-key-method": "hidden"
                },   
                "fields": {
                    "LW3SFID": {"value": store.getters.storefront},
                    "META_VALUE": {"value": meta_value}
                },   
            }
        })
        .then((response) => {
            const RESOURCES = response.data.webroutine.lists.RESOURCES;
            if (RESOURCES.entries.length > 0){
                // console.log(RESOURCES.entries);
                
                if (publicIdOnly){
                    return RESOURCES.entries[0].CL_PUBID;
                }else{
                    // return RESOURCES.entries[0].CL_RESURL;
                }

                const clImage = Cloudinary.image(RESOURCES.entries[0].CL_PUBID);
                if (scaleWidth > 0){
                    clImage.resize(scale().width(scaleWidth));
                }
                return clImage.toURL();
            }else if(this.manufacturer_code) {
                const mfgs = store.getters.mfgs_imgs;
                const mfg = mfgs.find(m => (m.CL_MFGCODE == this.manufacturer_code));
                // console.log(mfgs);
                if (mfg){
                    if (publicIdOnly){
                        return mfg.CL_PUBID;
                    }

                    const clImage = Cloudinary.image(mfg.CL_PUBID);
                    if (scaleWidth > 0){
                        clImage.resize(scale().width(scaleWidth));
                    }
                    return clImage.toURL();
                }
                
                return false;
            }else{
                return false;
            }
        });
    }

    vlWidgetGallery(meta){
        // console.log('vlWidgetGallery');
        const meta_value = this.__metaValue(meta);

        const url = store.getters['api/cl_mware_swmetadata_uri'];
        const gallery = [];
        
        return axiosvl.post(url, {
            "webroutine": {
                "context": {
                    "session-key-method": "hidden"
                },
                "fields": {
                    // "HOSTURL": {"value": store.getters.hosturl},
                    "LW3SFID": {"value": store.getters.storefront},
                    "META_VALUE": {"value": meta_value}
                },   
            }
        })
        .then((response) => {
            const GALLERY_IMGS = response.data.webroutine.lists.GALLERY_IMGS;
            if (GALLERY_IMGS.entries.length > 0){

                GALLERY_IMGS.entries.forEach(i => {
                    // build the meta data as object
                    let metadata;
                    if (this.isJson(i.CL_METADATA)){
                        metadata = JSON.parse(i.CL_METADATA);
                    }else {
                        metadata = '';
                    }


                    // get the media type
                    let mediaType;
                    if(metadata != ''){
                        if(metadata.resourcetype.find(m => m == GCONST.CL_METARTYPE_3D)){
                            mediaType = '3d';
                        }else{
                            mediaType = i.CL_RTYPE;
                        }
                    }else{
                        mediaType = i.CL_RTYPE;
                    }

                    gallery.push({
                        "publicId": i.CL_PUBID,
                        "mediaType": mediaType,
                        "sequence": metadata['gallery-seq']
                    });
                });

                return gallery;
            }else if(this.manufacturer_code) {
                const mfgs = store.getters.mfgs_imgs;
                const mfg = mfgs.find(m => (m.CL_MFGCODE == this.manufacturer_code));

                if (mfg){
                    gallery.push({
                        "publicId": mfg.CL_PUBID,
                        "mediaType": 'image',
                        "sequence": 1
                    });
                }else{
                    const mfg = mfgs.find(m => (m.CL_MFGCODE == 'DEFAULT'));
                    // console.log(mfg);
                    gallery.push({
                        "publicId": mfg.CL_PUBID,
                        "mediaType": 'image',
                        "sequence": 1
                    });
                }
                
                return gallery;
            }else{
                return false;
            }
        });
    }

    vlLatestProducts(meta){
        const meta_value = this.__metaValue(meta);

        const url = store.getters['api/cl_mware_swmetadata_uri'];
        
        return axiosvl.post(url, {
            "webroutine": {
                "context": {
                    "session-key-method": "hidden"
                },   
                "fields": {
                    // "HOSTURL": {"value": store.getters.hosturl},
                    "LW3SFID": {"value": store.getters.storefront},
                    "META_VALUE": {"value": meta_value}
                },   
            }
        })
        .then((response) => {
            const GALLERY_IMGS = response.data.webroutine.lists.GALLERY_IMGS;
            if (GALLERY_IMGS.entries.length > 0){
                const images = [];
                GALLERY_IMGS.entries.forEach(i => {
                    let metadata;
                    if (this.isJson(i.CL_METADATA)){
                        metadata = JSON.parse(i.CL_METADATA);
                    }else {
                        metadata = '';
                    }
                    // console.log(metadata);
                    images.push({
                        "publicId": i.CL_PUBID,
                        "mediaType": i.CL_RTYPE,
                        "metadata": metadata
                    });
                });
                return images;
            }else{
                return false;
            }
        });
    }

    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            console.log('error json string');
            return false;
        }
        return true;
    }

    /**
     * build the meta value expression
     */
    __metaValue(meta_key) {
        let metaVal = '';
        let last_minus = false;
        let folder = '';

        if (store.getters.storefrontAttributes.length > 0) {
            folder = store.getters.storefrontAttributes.find(attribute => attribute.type === 'CMF').value;
        } else {
            folder = 'DMS-Auto';
        }

        switch (meta_key){
            // product gallery
            case GCONST.CL_ITEM_GALLERY:
                // eslint-disable-next-line no-case-declarations
                // const formatString = this.item_sku.match(/[a-z]|[0-9]|/gi).join('');
                metaVal = 'metadata.' + GCONST.CL_META_ITEM_SKU + ':\\"' + this.item_sku + '\\" AND metadata.' + GCONST.CL_META_MFG_CODE + '=\\"' + this.manufacturer_code + '\\" AND metadata.resourcetype:' + GCONST.CL_METARTYPE_ITEM + ' AND folder=' + folder +'/*';
                // console.log(metaVal);
            break;

            // product image
            case GCONST.CL_META_ITEM_SKU:
                metaVal = 'metadata.' + GCONST.CL_META_ITEM_SKU + ':\\"' + this.item_sku + '\\" AND metadata.' + GCONST.CL_META_MFG_CODE + '=\\"' + this.manufacturer_code + '\\" AND metadata.resourcetype:' + GCONST.CL_METARTYPE_ITEM;
                // + ' AND metadata.' + GCONST.CL_META_GALLERY_SEQ + '=0'
            break;

            // manufacturers 
            case GCONST.CL_META_MFG_CODE:
                metaVal = 'metadata.' + GCONST.CL_META_MFG_CODE + '=\\"' + this.manufacturer_code + '\\" AND metadata.resourcetype:' + GCONST.CL_METARTYPE_MFG + ' AND folder=' + folder +'/*';
            break;

            // product categories
            case GCONST.CL_META_CATEGORY_ID:
                metaVal = 'metadata.' + GCONST.CL_META_CATEGORY_ID + '=' + this.category_id;
                metaVal += ' AND metadata.resourcetype:' + GCONST.CL_METARTYPE_CATEGORY + ' AND folder=' + folder +'/*';

                if (this.category_2 != ''){
                    metaVal += ' AND metadata.' + GCONST.CL_META_CATEGORY_ID_2 + ':' + this.category_2;
                }else{
                    last_minus = true;
                    metaVal += ' AND -metadata=' + GCONST.CL_META_CATEGORY_ID_2;
                }

                if (this.category_3 != ''){
                    metaVal += ' AND metadata.' + GCONST.CL_META_CATEGORY_ID_3 + ':' + this.category_3;
                }else{
                    if (!last_minus){
                        last_minus = true;
                        metaVal += ' AND -metadata=' + GCONST.CL_META_CATEGORY_ID_3;
                    } 
                }

                if (this.category_4 != ''){
                    metaVal += ' AND metadata.' + GCONST.CL_META_CATEGORY_ID_4 + ':' + this.category_4 ;
                }else{
                    if (!last_minus){
                        last_minus = true;
                        metaVal += ' AND -metadata=' + GCONST.CL_META_CATEGORY_ID_4;
                    }
                }

                if (this.category_5 != ''){
                    metaVal += ' AND metadata.' + GCONST.CL_META_CATEGORY_ID_5 + ':' + this.category_5 ;
                }else{
                    if (!last_minus){
                        last_minus = true;
                        metaVal += ' AND -metadata=' + GCONST.CL_META_CATEGORY_ID_5;
                    }
                }

                if (this.category_6 != ''){
                    metaVal += ' AND metadata.' + GCONST.CL_META_CATEGORY_ID_6 + ':' + this.category_6 ;
                }else{
                    if (!last_minus){
                        last_minus = true;
                        metaVal += ' AND -metadata=' + GCONST.CL_META_CATEGORY_ID_6;
                    }
                }

                if (this.category_7 != ''){
                    metaVal += ' AND metadata.' + GCONST.CL_META_CATEGORY_ID_7 + ':' + this.category_7 ;
                }else{
                    if (!last_minus){
                        last_minus = true;
                        metaVal += ' AND -metadata=' + GCONST.CL_META_CATEGORY_ID_7;
                    }
                }

                if (this.category_8 != ''){
                    metaVal += ' AND metadata.' + GCONST.CL_META_CATEGORY_ID_8 + ':' + this.category_8 ;
                }else{
                    if (!last_minus){
                        last_minus = true;
                        metaVal += ' AND -metadata=' + GCONST.CL_META_CATEGORY_ID_8;
                    }
                }

                if (this.category_9 != ''){
                    metaVal += ' AND metadata.' + GCONST.CL_META_CATEGORY_ID_9 + ':' + this.category_9 ;
                }else{
                    if (!last_minus){
                        last_minus = true;
                        metaVal += ' AND -metadata=' + GCONST.CL_META_CATEGORY_ID_9;
                    }
                }

                if (this.category_10 != ''){
                    metaVal += ' AND metadata.' + GCONST.CL_META_CATEGORY_ID_10 + ':' + this.category_10 ;
                }else{
                    if (!last_minus){
                        last_minus = true;
                        metaVal += ' AND -metadata=' + GCONST.CL_META_CATEGORY_ID_10;
                    }
                }
                // console.log(metaVal);
            break;

            // product category diagam
            case GCONST.CL_META_DIAGRAM_ID:

                // metaVal = 'metadata.resourcetype:' + GCONST.CL_METARTYPE_PDIAGRAM;
                // metaVal = 'metadata.' + GCONST.CL_META_DIAGRAM_ID + ':' + this.diagram_id + ' AND metadata.resourcetype:' + GCONST.CL_METARTYPE_PDIAGRAM + ' AND folder=' + folder +'/*';
                metaVal = 'metadata.resourcetype:' + GCONST.CL_METARTYPE_CATEGORY + ' AND folder=' + folder +'/*';

                this.category_codes.forEach(code => {
                    if(code.metavalue != '')
                        metaVal += ' AND metadata.' + code.metakey + ':' + code.metavalue;
                });
                // console.log('metaval = ' + metaVal);
            break;

            // latest products
            case GCONST.CL_METARTYPE_LATEST:
                metaVal = 'metadata.resourcetype:' + GCONST.CL_METARTYPE_LATEST + ' AND folder=' + folder +'/*';
            break;

            // featured products
            case GCONST.CL_METARTYPE_FEATURED:
                metaVal = 'metadata.resourcetype:' + GCONST.CL_METARTYPE_FEATURED + ' AND folder=' + folder +'/*';
                // console.log(metaVal);
            break;

            // slider images
            case GCONST.CL_METARTYPE_SLIDER:
                metaVal = 'metadata.resourcetype:' + GCONST.CL_METARTYPE_SLIDER + ' AND folder=' + folder +'/'+ this.slider_folder +'/*';
            break;

            case GCONST.CL_METARTYPE_CATEGORY_ONLY:
                metaVal = 'metadata.resourcetype:' + GCONST.CL_METARTYPE_CATEGORY + ' AND folder=' + folder +'/* AND -metadata=DXCD02';
            break;

            case GCONST.CL_METARTYPE_PARTSLINK:
                metaVal = 'metadata.' + GCONST.CL_META_ITEM_SKU + '=\\"' + this.item_sku + '\\" AND metadata.' + GCONST.CL_META_MFG_CODE + '=\\"' + this.manufacturer_code + '\\" AND metadata.resourcetype:' + GCONST.CL_METARTYPE_PARTSLINK;
            break;
        }

        return metaVal;
    }

    manufacturer_img(mfgcode, scaleWidth = 0) {
        const mfgs = store.getters.mfgs_imgs;
        const mfg = mfgs.find(m => (m.CL_MFGCODE == mfgcode));

        if (mfg){
            const clImage = Cloudinary.image(mfg.CL_PUBID);
            if (scaleWidth > 0){
                clImage.resize(scale().width(scaleWidth));
            }
            return clImage.toURL();
        }

        return GCONST.THUMB_IMAGE_PLACEHOLDER;
    }
}

export default CloudinaryApi;
